import React from "react";
import { useConfig } from "../../../../providers/config";
import { useHistory } from "react-router";
import { AddressSelectionModal } from "../../../../parhato2/src/entities";
import { useTranslation } from "react-i18next";
import PaymentCardsList from "../../../../parhato2/src/entities/PaymentCardsList";
import { IonIcon } from "@ionic/react";
import { giftOutline, locationOutline, optionsOutline, readerOutline } from "ionicons/icons";
import ReferralStatsBottomSheet from "./ReferralStatsBottomSheet";

const cardBase =
  "flex items-center justify-center w-full text-center rounded-2xl bg-[#f6f6f6] shadow-sm px-4 py-3 md:px-6 h-[60px]  cursor-pointer transition active:scale-[0.97]";

const Additional = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const history = useHistory();

  const handleGoToInvite = () => history.push("/invite-friend");
  const handleGoToOfferta = () => history.push("/offerta");
  const handleGoToSettings = () => history.push("/settings");

  const renderAddressSelectionPreview = () => (
    <div className="flex items-center justify-center py-2 gap-2 text-gray-900">
      <IonIcon icon={locationOutline} className="w-5 h-5 text-blue-500" />
      <div className="text-sm">{t("Addresses")}</div>
    </div>
  );

  return (
    <div className="flex flex-col gap-3 mt-3">
      <div className="font-bold text-[1.0625rem]">{t("Additional")}</div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {config.isInviteEnabled && (
          <div className={cardBase} onClick={handleGoToInvite}>
            <IonIcon icon={giftOutline} className="w-5 h-5 text-orange-500 mr-3" />
            <span className="text-sm">{t("Invite a friend")}</span>
          </div>
        )}

        {config.isReferralStatsEnabled && (
          <div className={cardBase}>
            <ReferralStatsBottomSheet />
          </div>
        )}

        {config.isCustomerAdressesEnabled && (
          <div className={cardBase}>
            <AddressSelectionModal customPreview={renderAddressSelectionPreview} />
          </div>
        )}

        {config.isSettingsPageEnabled && (
          <div className={cardBase} onClick={handleGoToSettings}>
            <IonIcon icon={optionsOutline} className="w-6 h-6  text-blue-500 mr-3" />
            <span className="text-sm">{t("Settings")}</span>
          </div>
        )}

        {config.isOffertaPageEnabled && (
          <div className={cardBase} onClick={handleGoToOfferta}>
            <IonIcon icon={readerOutline} className="w-6 h-6 text-green-500 mr-3" />
            <span className="text-sm">{t("Offerta")}</span>
          </div>
        )}

        {config.isCardsEnabled && (
          <div className={cardBase + "col-span-2 md:col-span-1"}>
            <PaymentCardsList />
          </div>
        )}
      </div>
    </div>
  );
};

export default Additional;
